exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".project-name{border-radius:5px;color:#fff;width:90%;font-size:40px;margin:30px auto 10px;text-align:center}.search-bar{height:24px;margin:auto 20px auto 0}.checklist-title{font-size:24px;display:flex;justify-content:center;align-items:center;height:40px;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58050330","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/checklist-container.vue
// module id = 389
// module chunks = 0